/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Undo: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0.473 4.83047L4.6835 1.38547C5.0095 1.11847 5.5 1.35097 5.5 1.77247V4.21747H10.6875C12.7385 4.21747 13.9825 5.12047 14.665 5.87797C15.5255 6.83397 16 8.11047 16 9.47297C16 12.085 14.175 14.7285 10.6875 14.7285H9.6875C9.411 14.7285 9.1875 14.505 9.1875 14.2285V13.2285C9.1875 12.9525 9.411 12.7285 9.6875 12.7285H10.6875C12.9755 12.7285 14 11.0935 14 9.47297C14 8.61847 13.7005 7.79597 13.1785 7.21647C12.5895 6.56297 11.7285 6.21747 10.6875 6.21747H5.5V8.66247C5.5 9.08397 5.0095 9.31647 4.6835 9.04947L0.473 5.60447C0.228499 5.40447 0.228499 5.03047 0.473 4.83047Z'
			/>
		</Svg>
	);
};

export { Undo };
